export const hasTouchScreen = () => {
  return navigator.maxTouchPoints > 0
}
